import React, { PropsWithChildren } from 'react';
import { StatsContainerRoot, StatsContainerInner } from '@screens/players/stats.container.styles';

interface StatsContainerProps {
  outlined?: boolean;
  column?: boolean;
  subContainer?: boolean;
  expandHeight?: boolean;
}

export const StatsContainer = ({ outlined, column, subContainer, expandHeight, children }: PropsWithChildren<StatsContainerProps>) => {
  return (
    <StatsContainerRoot outlined={outlined} expandHeight={expandHeight}>
      <StatsContainerInner column={column} subContainer={subContainer}>
        {children}
      </StatsContainerInner>
    </StatsContainerRoot>
  );
};
